import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Wizard from './Wizard'
import { apiRequest, ajaxWatched } from '../../shared/services';
import { ensureMeta } from '../../shared/actions/meta';

// {host}/record/edit/:collectionId

function getRecord(recordId, callback){
    return (dispatch, getState) => {
        dispatch(ajaxWatched(
            apiRequest(dispatch, getState, '/api/record/id/' + recordId)
                .then(callback)));
    }
}

function updateRecord(collectionId, recordId, data, callback) {
    return (dispatch, getState) => {
        dispatch(
            ajaxWatched(
                apiRequest(dispatch, getState,'/api/record/save/' + collectionId + '/' + recordId,
                    {
                        'method': 'PUT',
                        'body': JSON.stringify(data)
                    })
                .then(callback)));
    }
}

class EditRecord extends Component {
    componentWillMount() {
        //this.props.dispatch(this.loadRecord(this.props.match.params.recordId));
        this.props.dispatch(getRecord(
            this.props.match.params.recordId,
            json => {
                this.props.dispatch(ensureMeta(json.collection.id));
                this.setState({selectedRecord: {...json.record, collection: json.collection}});
            }));
    }

    state = {
        selectedRecord: null,
        saveErrors: null,
        redirectTo: null
    }

    saveChanges = data => {
        this.props.dispatch(updateRecord(
            this.state.selectedRecord.collectionId,
            this.state.selectedRecord.id,
            data,
            json => {
                if (json.success) {
                    this.setState({redirectTo: '/app/record/saved/' + this.state.selectedRecord.collectionId, saveErrors: null});
                } else {
                    this.setState({
                        selectedRecord: {...json.record, collection: json.collection },
                        saveErrors: json.errors
                    });
                }
            }
        ));
    }

    render() {
        if (this.state.redirectTo) {
            return <Redirect to={this.state.redirectTo} />;
        }

        if (this.state.selectedRecord) {
            return <Wizard record={this.state.selectedRecord} onSubmit={this.saveChanges} errors={this.state.saveErrors} />;
        }

        return null;
    }
}

export default connect((state) => { return {}})(EditRecord);